/**
 * Helper to calculate percentage (0-100) with rounding.
 * Returns 0 if denominator is 0.
 */
export function toPercent(
  numerator: number,
  denominator: number,
  decimals = 2,
): number {
  if (denominator === 0) return 0
  const factor = 10 ** decimals
  return Math.round((numerator / denominator) * 100 * factor) / factor
}
export const roundCurrency = (val: number) => +val.toFixed(2)
